<template>
	<div class="p-grid">
		<div class="p-col-12">
<!--			<div class="card">-->
<!--        <Toolbar class="p-mb-4 p-p-2">-->
<!--          <template #start>-->
<!--            <div style="font-size: 1.4em; color: inherit" class="p-p-2">Pricing Calculator</div>-->
<!--&lt;!&ndash;            <AddNewButton :label="$t('Add')" @click="addNewItem" />&ndash;&gt;-->
<!--          </template>-->
<!--        </Toolbar>-->

        <VGPricingCalculator/>
<!--			</div>-->

		</div>
	</div>
</template>

<script>
// import httpClient from '@/services/http.services'
// import datatableMixins from "@/mixins/datatableMixins";
// import settings from "@/settings";
// import formatMixins from "@/mixins/formatMixins";
// import showErrorsMixins from "@/mixins/showErrorsMixins";
import VGPricingCalculator from "@/pages/system/components/VGPricingCalculator.vue";

export default {
  // mixins: [ datatableMixins ],
  components: { VGPricingCalculator },
  // components: { SmsSenderStatus, AcceptButton},
	data() {
		return {
		}
	},
  // mounted() {
  //   this.scrollToTop()
  //   if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
  //   this.checkRouteQuery()
  //   this.getPageData()
	// },
}
</script>